// extracted by mini-css-extract-plugin
export default {"trigger-disabled":"TreatmentTypeDropdown_trigger-disabled__uYSXJ","triggerDisabled":"TreatmentTypeDropdown_trigger-disabled__uYSXJ","trigger":"TreatmentTypeDropdown_trigger__6w-Xo"};